import InputRatingView from './InputRatingView';

export default InputRatingView;
